import React from "react";
import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";

function Postmention() {
  return (
    <div className="container mx-auto px-4 md:px-6 lg:px-8">
      <div className="bg-[#9AD7D2] rounded-2xl md:rounded-3xl py-12 md:py-16 lg:py-20 px-4 md:px-8 flex justify-center items-center my-8 md:my-12 lg:my-16">
        <div className="text-center max-w-3xl">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold font-custom mb-6 md:mb-8 leading-tight">
            Ready To Create Some <br className="hidden sm:block" /> Custom Products?
          </h2>
          <Button
            type="default"
            className="bg-white text-[#6cc5bf] font-semibold font-custom
              px-6 md:px-8 py-3 md:py-4 h-auto 
              rounded-full border-none 
              text-sm md:text-base lg:text-lg
              inline-flex items-center justify-center gap-2
              hover:!bg-[#6cc5bf] hover:!text-white 
              transition-all duration-300
              shadow-lg hover:shadow-xl
              transform hover:scale-105"
          >
            <span>Explore More</span>
            <RightOutlined className="text-sm md:text-base" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Postmention;